'use client';
import React from 'react';
import { Logo as SharedLogo } from '@launchstore/shared-puck';
import type { LogoProps } from '@launchstore/shared-puck';

export const Logo: any = SharedLogo;
export type { LogoProps };
export default Logo;
